/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import moment from 'moment';
import { DownloadIcon, SearchIcon, TabOwnersIcon } from '../../../assets/icons';
import { classNames, Constants, formatAmount, formatMiles, fromStorage, getUpdatedState } from '../../../utils';
import { Input, Pagination, Render } from '../../../components';
import { ReportService } from '../../../services';

const ReportBilling = () => {
  const { data, filters, goToPage, onChange, downloadAll, downloadOne, pagination, reload, search, totals } = useFetchTable();

  return (
    <main className="w-full">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="flex flex-1 flex-wrap items-end gap-3">
          <Input
            className={{ base: 'max-w-60' }}
            placeholder="Buscar nombre, CI o RIF"
            value={filters.search}
            onValueChange={v => onChange('search', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <Input
            className={{ base: 'max-w-44' }}
            type="date"
            label="Desde"
            value={filters.since}
            onValueChange={v => onChange('since', v)}
          />

          <Input
            className={{ base: 'max-w-44' }}
            type="date"
            label="Hasta"
            value={filters.until}
            onValueChange={v => onChange('until', v)}
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => search()}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      <div className="flex justify-between items-start">
        <div className="flex items-center gap-4 my-2">
          <Tab
            label="Clientes"
            icon={TabOwnersIcon}
            isActive={filters.destiny === Constants.BILLING.DESTINY.CLIENT}
            onClick={() => {
              onChange('destiny', Constants.BILLING.DESTINY.CLIENT);
              search();
            }}
          />
          <Tab
            label="Propietarios"
            icon={TabOwnersIcon}
            isActive={filters.destiny === Constants.BILLING.DESTINY.OWNER}
            onClick={() => {
            onChange('destiny', Constants.BILLING.DESTINY.OWNER);
            search();
          }}
          />
          <Tab
            label="Conductores"
            icon={TabOwnersIcon}
            isActive={filters.destiny === Constants.BILLING.DESTINY.DRIVER}
            onClick={() => {
            onChange('destiny', Constants.BILLING.DESTINY.DRIVER);
            search();
          }}
          />
        </div>

        <div className="text-right text-white font-semibold bg-orange flex items-center justify-between gap-10 px-3 py-1 rounded-xl">
          <p className="text-xl font-bold">Total General</p>
          <div className="text-right">
            <p className="text-2xl font-black">{ formatAmount(totals?.amount, '$') }</p>
            <p className="text-lg font-semibold">{ formatAmount(totals?.amount_local, 'Bs. ') }</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-md overflow-hidden mt-6">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">Historial de facturación por cliente</p>

          <Render condition={!filters.since && !filters.until}>
            <button className="border border-orange text-orange bg-orange/10 font-bold px-3 py-1.5 rounded-full text-sm space-x-2">
              <span>HOY</span>
              <span className="text-black font-semibold">{ moment().format('DD-MM-YYYY') }</span>
            </button>
          </Render>

          <button
            className="flex items-center gap-2 bg-black text-white px-4 py-1.5 rounded-lg font-semibold"
            onClick={() => toast.promise(downloadAll(), { loading: 'Descargando...', success: 'Reporte descargado con éxito', error: 'Error al descargar el reporte' })}
          >
            <img src={DownloadIcon} className="w-4 h-4 brightness-200" alt="" />
            Descargar
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:break-words [&>th]:max-w-36 text-default font-semibold align-bottom">
                <th>
                  <span hidden={filters.destiny !== Constants.BILLING.DESTINY.CLIENT} className="pl-4">Cliente</span>
                  <span hidden={filters.destiny !== Constants.BILLING.DESTINY.OWNER} className="pl-4">Propietario</span>
                  <span hidden={filters.destiny !== Constants.BILLING.DESTINY.DRIVER} className="pl-4">Conductor</span>
                </th>
                <th>Monto (Bs)</th>
                <th>Monto ($)</th>
                <th>Porcentaje de la facturación</th>
                <th align="right">Acción</th>
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {data.map((item, index) => (
                <tr key={index} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:truncate [&>td]:max-w-36">
                  <th>
                    <span className="pl-4">
                      { filters.destiny === Constants.BILLING.DESTINY.CLIENT ? item?.user?.person?.company?.name : item?.user?.person?.name }
                    </span>
                  </th>
                  <td>{ formatMiles(item?.amount_local, true, 'Bs. ') }</td>
                  <td>{ formatMiles(item?.amount, true, '$') }</td>
                  <td>{ formatMiles(item?.percentage, true, '') }</td>
                  <td>
                    <div className="flex justify-end gap-3 pr-2">
                      <img
                        src={DownloadIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => {
                          toast.promise(
                            downloadOne(item?.id),
                            {
                              loading: 'Descargando...',
                              success: 'Reporte impreso con éxito',
                              error: 'Error al imprimir el reporte',
                            }
                          );
                        }}
                        alt=""
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">No se han encontrado registros</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const Tab = ({ label, icon, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={classNames('flex items-center gap-2 p-3 rounded-xl text-sm font-semibold shadow-md', isActive ? 'bg-orange' : 'bg-white')}
  >
    <div className={classNames('w-10 h-10 rounded-full flex items-center justify-center', isActive ? 'bg-white' : 'bg-[#F5F7FA]')}>
      <img src={icon} className={classNames('w-5 h-5 object-contain', isActive ? 'text-white' : 'text-orange')} alt="" />
    </div>
    <span className={classNames(' text-lg', isActive ? 'text-white' : 'black')}>{ label }</span>
  </button>
)

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    destiny: Constants.BILLING.DESTINY.CLIENT,
    user_id: '',
    search: '',
    since: '',
    until: '',
    status: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [totals, setTotals] = useState({
    amount: 0,
    amount_local: 0,
  });
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await ReportService.admin.billing.findAll(payload);
      const { data, totals, ...rest } = response;

      setData(data.map(x => ({ ...x, percentage: Number(x.amount) / Number(totals.amount) * 100 })));
      setTotals(totals);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const downloadAll = async () => {
    try {
      const response = await ReportService.admin.billing.downloadAll(filters);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      console.log(error);
    }
  }

  const downloadOne = async (id) => {
    try {
      const response = await ReportService.admin.billing.downloadOne(id);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.log(error);
    }
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters({ ...initialFilters, destiny: filters.destiny });
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    downloadAll,
    downloadOne,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
    totals,
  }
}

export default ReportBilling;